import {Injectable} from '@angular/core';
import {AppHttpClient} from 'common/core/http/app-http-client.service';
import {Observable} from 'rxjs';
import {SearchResponse} from './search-results';
import {BackendResponse} from '@common/core/types/backend-response';
import {Track} from '../../models/Track';

interface SearchEverythingParams {
    limit?: number;
    forceLocal?: boolean;
    flatten?: boolean;
    modelTypes: string[];
}

@Injectable({
    providedIn: 'root'
})
export class Search {
    constructor(private http: AppHttpClient) {}

    public media(query: string, params?: SearchEverythingParams): BackendResponse<SearchResponse> {
        return this.http.get('search/' + encodeURIComponent(query), params);
    }

    public videoId(artist: string, track: Track): Observable<{ title: string, id: string }[]> {
        const artistName = this.encode(artist),
            trackName = this.encode(track.name);
        return this.http.get(`search/audio/${track.id}/${artistName}/${trackName}`);
    }

    private encode(string: string): string {
        return encodeURIComponent((string || '').replace('/', '-'));
    }
}
